import { EXTENSIONES_ARCHIVO } from "@gestiondoc/shared";
import { type DragEvent, useId, useState } from "react";
import { formatearTamano } from "../utiles.ts";

/**
 * El recuadro para soltar o elegir archivos (Word, Excel o PDF). De a uno, muestra el elegido y
 * deja cambiarlo; con `multiple`, entrega todos los soltados y queda listo para más.
 */
type PropsDeUno = {
  multiple?: false;
  archivo: File | null;
  onArchivo: (f: File | null) => void;
  error?: string | undefined;
};
type PropsDeVarios = {
  multiple: true;
  onArchivos: (archivos: File[]) => void;
  /** Lo que dice el recuadro. */
  texto: string;
};

export function Dropzone(props: PropsDeUno | PropsDeVarios) {
  const id = useId();
  const [arrastrando, setArrastrando] = useState(false);
  const error = props.multiple ? undefined : props.error;

  function recibir(archivos: FileList | null) {
    const lista = [...(archivos ?? [])];
    if (props.multiple) props.onArchivos(lista);
    else props.onArchivo(lista[0] ?? null);
  }

  function soltar(e: DragEvent) {
    e.preventDefault();
    setArrastrando(false);
    if (props.multiple || e.dataTransfer.files.length > 0) recibir(e.dataTransfer.files);
  }

  return (
    <div>
      <input
        id={id}
        type="file"
        multiple={props.multiple}
        accept={EXTENSIONES_ARCHIVO.map((e) => `.${e}`).join(",")}
        className="sr-only"
        onChange={(e) => {
          recibir(e.target.files);
          // Se vacía el campo: elegir los mismos archivos otra vez vuelve a disparar.
          if (props.multiple) e.target.value = "";
        }}
      />
      <label
        htmlFor={id}
        onDragOver={(e) => {
          e.preventDefault();
          setArrastrando(true);
        }}
        onDragLeave={() => setArrastrando(false)}
        onDrop={soltar}
        className={`block cursor-pointer rounded-tarjeta border-2 border-dashed p-5 text-center text-[12.5px] ${
          arrastrando
            ? "border-marino bg-marino-claro"
            : "border-borde bg-fondo hover:border-marino"
        } ${error ? "border-rojo" : ""}`}
      >
        {props.multiple ? (
          <div className="text-texto-3">{props.texto}</div>
        ) : props.archivo ? (
          <div>
            <div className="font-semibold text-marino">{props.archivo.name}</div>
            <div className="text-texto-3">
              {formatearTamano(props.archivo.size)} ✓ · <span className="underline">cambiar</span>
            </div>
          </div>
        ) : (
          <div className="text-texto-3">Arrastra el archivo aquí o haz clic</div>
        )}
      </label>
      {error && <div className="mt-1 text-[11.5px] text-rojo">{error}</div>}
    </div>
  );
}
